import { Type } from 'class-transformer';
import {
  IsBoolean,
  IsDate,
  IsDefined,
  IsNotEmpty,
  IsOptional,
  IsString,
  ValidateNested,
} from 'class-validator';
import { BaseDto } from '../../@base/base.dto';
import { StripeSubscriptionStatus, SubscriptionId } from '../../types';
import { UserSummaryDto } from './user-summary.dto';

export class PlanSummaryDto {
  @IsString()
  @IsNotEmpty()
  name!: string;

  @IsString()
  @IsNotEmpty()
  billingCycle!: string;

  @IsNotEmpty()
  price!: number;

  @IsString()
  @IsNotEmpty()
  currency!: string;
}

export class SubscriptionStripeMetadataDto {
  @IsString()
  @IsNotEmpty()
  subscriptionId!: string;

  @IsString()
  @IsNotEmpty()
  customerId!: string;
}

export class SubscriptionSummaryMetadataDto {
  @ValidateNested()
  @Type(() => SubscriptionStripeMetadataDto)
  stripe!: SubscriptionStripeMetadataDto;
}

export class SubscriptionSummaryDto extends BaseDto<SubscriptionId> {
  @ValidateNested()
  @Type(() => UserSummaryDto)
  @IsDefined()
  user!: UserSummaryDto;

  @ValidateNested()
  @Type(() => PlanSummaryDto)
  @IsDefined()
  plan!: PlanSummaryDto;

  @IsString()
  @IsNotEmpty()
  status!: StripeSubscriptionStatus;

  @IsDate()
  @IsDefined()
  currentPeriodStart!: Date;

  @IsDate()
  @IsDefined()
  currentPeriodEnd!: Date;

  @IsBoolean()
  @IsDefined()
  cancelAtPeriodEnd!: boolean;

  @ValidateNested()
  @Type(() => SubscriptionSummaryMetadataDto)
  @IsOptional()
  metadata?: SubscriptionSummaryMetadataDto;
}
